import React from "react";
import FundAnalysis from "../../features/icfundanalysis";

const FundAnalysisReturnPage = () => <FundAnalysis />

export default FundAnalysisReturnPage;